import ampLocale from '@amplify/amp-locale/dist/amp-locale';

import { DICTIONARY_KEYS, LANGUAGES } from './consts';

export const languagesDictionary = {
    [LANGUAGES.ENGLISH]: {
        [DICTIONARY_KEYS.NAME]: 'Name',
        [DICTIONARY_KEYS.TRC]: 'TRC',
        [DICTIONARY_KEYS.ASSESS]: 'Assess',
        [DICTIONARY_KEYS.RESUME]: 'Resume',
        [DICTIONARY_KEYS.FORM]: 'Form',
        [DICTIONARY_KEYS.SKILL]: 'Skill',
        [DICTIONARY_KEYS.ALL_MEASURES]: 'All measures',
        [DICTIONARY_KEYS.SELECT_A_MEASURE]: 'Select a measure',
        [DICTIONARY_KEYS.SCORE]: 'Score',
        [DICTIONARY_KEYS.DATE]: 'Date',
        [DICTIONARY_KEYS.PROGRESS_MONITORING_HISTORY]: 'Progress Monitoring History',
        [DICTIONARY_KEYS.PAUSED]: 'Paused',
        [DICTIONARY_KEYS.RECOMMENDED]: 'Recommended',
        [DICTIONARY_KEYS.TEXT_READING_COMPREHENSION]: 'Text Reading Comprehension',
        [DICTIONARY_KEYS.OPTIONAL]: 'Optional',
        [DICTIONARY_KEYS.INVENTORY]: 'Inventory',
        [DICTIONARY_KEYS.LISTENING_COMPREHENSION]: 'Listening Comprehension',
        [DICTIONARY_KEYS.ORAL_LANGUAGE]: 'Oral Language',
        [DICTIONARY_KEYS.OL]: 'OL',
        [DICTIONARY_KEYS.AMPLIFY_ORAL_LANGUAGE_SCREENER]: 'Oral Language',
        [DICTIONARY_KEYS.YOU_ARE_DONE_PROGRESS_MONITORING_THIS_STUDENT_TODAY]:
            'You are done progress monitoring this student today',
        [DICTIONARY_KEYS.NO_PROGRESS_MONITORING_HISTORY_YET]: 'No Progress Monitoring history yet',
        [DICTIONARY_KEYS.RECOMMENDED_MEASURES]: 'Recommended Measures',
        [DICTIONARY_KEYS.RECOMMENDED_DESCRIPTION]:
            'The following measures are recommended based on a student performance. Consider the targeted area of instruction when selecting a measure for progress monitoring.',
        [DICTIONARY_KEYS.DISCONTINUED]: 'Discontinued',
        [DICTIONARY_KEYS.TESTED_OUT]: 'Tested out',
        [DICTIONARY_KEYS.ON_TRACK]: 'On Track',
        [DICTIONARY_KEYS.OFF_TACK]: 'Off Track',
        [DICTIONARY_KEYS.ON_TRACK_TEXT]:
            'This student is on track to meet the goal for this skill and may need less frequent progress monitoring.',
        [DICTIONARY_KEYS.OFF_TRACK_TEXT]:
            'This student may not be making sufficient progress with this skill. A change in intervention or off-grade level progress monitoring may be needed.',
    },
    [LANGUAGES.SPANISH]: {
        [DICTIONARY_KEYS.NAME]: 'Nombre',
        [DICTIONARY_KEYS.TRC]: 'TRC',
        [DICTIONARY_KEYS.ASSESS]: 'Evaluar',
        [DICTIONARY_KEYS.RESUME]: 'Reanudar',
        [DICTIONARY_KEYS.FORM]: 'Formulario',
        [DICTIONARY_KEYS.SKILL]: 'Habilidad',
        [DICTIONARY_KEYS.ALL_MEASURES]: 'Todas las mediciones',
        [DICTIONARY_KEYS.SELECT_A_MEASURE]: 'Seleccione una medición',
        [DICTIONARY_KEYS.SCORE]: 'Puntaje',
        [DICTIONARY_KEYS.DATE]: 'Fecha',
        [DICTIONARY_KEYS.PROGRESS_MONITORING_HISTORY]: 'Historial de monitoreo de progreso',
        [DICTIONARY_KEYS.PAUSED]: 'En pausa',
        [DICTIONARY_KEYS.RECOMMENDED]: 'recomendada',
        [DICTIONARY_KEYS.TEXT_READING_COMPREHENSION]: 'Comprensión lectora',
        [DICTIONARY_KEYS.OPTIONAL]: 'Optativa',
        [DICTIONARY_KEYS.INVENTORY]: 'Inventario',
        [DICTIONARY_KEYS.LISTENING_COMPREHENSION]: 'Comprensión auditiva',
        [DICTIONARY_KEYS.ORAL_LANGUAGE]: 'Lenguaje oral',
        [DICTIONARY_KEYS.OL]: 'LO',
        [DICTIONARY_KEYS.AMPLIFY_ORAL_LANGUAGE_SCREENER]: 'Oral Language',
        [DICTIONARY_KEYS.YOU_ARE_DONE_PROGRESS_MONITORING_THIS_STUDENT_TODAY]:
            'Usted ha terminado por hoy el monitoreo de progreso de este estudiante',
        [DICTIONARY_KEYS.NO_PROGRESS_MONITORING_HISTORY_YET]:
            'Todavía no hay historial de monitoreo de progreso',
        [DICTIONARY_KEYS.RECOMMENDED_MEASURES]: 'Mediciones recomendadas',
        [DICTIONARY_KEYS.RECOMMENDED_DESCRIPTION]:
            'Teniendo en cuenta el desempeño del estudiante, se recomiendan las siguientes mediciones. Antes de seleccionar una medición para monitoreo de progreso, considere el área de instrucción deseada.',
        [DICTIONARY_KEYS.DISCONTINUED]: 'Interrumpida',
        [DICTIONARY_KEYS.TESTED_OUT]: 'Exento/a',
        [DICTIONARY_KEYS.ON_TRACK]: 'Apto',
        [DICTIONARY_KEYS.OFF_TACK]: 'Rezagado',
        [DICTIONARY_KEYS.ON_TRACK_TEXT]:
            'El progreso del estudiante es apto para alcanzar el objetivo de esta habilidad, y quizás requiera de monitoreo del progreso menos frecuente.',
        [DICTIONARY_KEYS.OFF_TRACK_TEXT]:
            'Este estudiante parece no estar progresando lo suficiente en esta habilidad. Quizás convenga modificar la intervención o hacerle monitoreo del progreso que no corresponda con el grado.',
    },
};

ampLocale.setDictionary(languagesDictionary);

export const setLanguage = appLanguage => ampLocale.setLanguage(appLanguage);

export default word => ampLocale.translate(word);
